<template>
  <div :class="$style['details-input']" v-background-color="colorBackground">
    <section>
      <page-header
        :tableNumber="tableNumber"
        :colorFont="colorFontBody"
        :fontDetail="fontDetailBody"
        hasBackButton
        @back="$emit('back')"
      >
        <page-indicator
          :colorPrimary="colorPrimary"
          :colorSecondary="colorSecondary"
          :index="2"
        />
      </page-header>
    </section>
    <section :class="$style['intro']" class="details-input__container">
      <h1
        v-if="receiptTitle"
        v-color="colorFontHeading"
        v-font-style="fontDetailHeading"
        v-text="receiptTitle"
      />
      <p
        v-if="receiptBodyText"
        v-color="colorFontBody"
        v-font-style="fontDetailBody"
        v-text="receiptBodyText"
      />
    </section>
    <section :class="$style['input-container']">
      <div class="details-input__input">
        <v-input
          placeholder="Your email"
          type="email"
          :colorFont="colorFontBody"
          :fontDetail="fontDetailBody"
          :label="receiptLabel"
          @input="handleInput"
          @formSubmit="handleContinue"
        />
        <p
          :class="$style['error-message']"
          v-if="!email && emailEntered"
          v-font-style="fontDetailBody"
          >Please enter a valid email address</p
        >
      </div>
    </section>
    <section :class="$style['footer']" v-background-color="colorBackground">
      <!-- <a
        :href="content && content.termsAndConditionsLink"
        class="details-input__footer-link"
        target="_blank"
      >
        Terms and Conditions
      </a>-->
      <v-button
        hasContainer
        :buttonText="receiptButtonText"
        :colorButton="colorPrimary"
        :colorButtonText="colorFontButton"
        :disabled="!email"
        :fontButton="fontDetailButton"
        @buttonClick="handleContinue"
      />
    </section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

const PageHeader = () => import('@components/page-header.vue')
const PageIndicator = () => import('@components/page-indicator.vue')
const VButton = () => import('@components/v-button.vue')
const VInput = () => import('@components/v-input.vue')

export default {
  components: {
    PageHeader,
    PageIndicator,
    VButton,
    VInput,
  },
  data: () => ({
    email: null,
    emailEntered: false,
  }),
  computed: {
    ...mapGetters('contentful', [
      'colorBackground',
      'colorPrimary',
      'colorSecondary',
      'colorFontBody',
      'colorFontButton',
      'colorFontHeading',
      'fontDetailBody',
      'fontDetailButton',
      'fontDetailHeading',
      'receiptTitle',
      'receiptBodyText',
      'receiptButtonText',
      'receiptLabel',
      'receiptOptOutText',
    ]),
    ...mapGetters('payment', ['tableNumber', 'totalIncludingDiscount']),
  },
  methods: {
    handleInput(input) {
      this.emailEntered = true
      if (
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          input
        )
      ) {
        this.email = input
      } else {
        this.email = null
      }
    },
    handleContinue() {
      if (this.email) {
        this.$emit('handleContinue', this.email)
      }
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';

.details-input {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: scroll;
  width: 100%;

  .intro {
    padding: 16px 16px 0;
  }

  .input-container {
    padding: 0 16px;
    margin-top: 40px;
  }

  .error-message {
    padding-top: 8px;
    color: $color-error;
    font-size: 14px;
  }

  .footer {
    bottom: 0;
    position: fixed;
    text-align: center;
    width: 100%;
  }
}
</style>
